import { render, staticRenderFns } from "./SubmissionFieldsHistory.vue?vue&type=template&id=55131e5b&"
import script from "./SubmissionFieldsHistory.vue?vue&type=script&lang=js&"
export * from "./SubmissionFieldsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports